import { FILTER_PANEL_TYPES } from '@app/components/filter-panel/filter-panel-types.enum';
import {
  FilterTypeView,
  IFilter,
  IFilterItem,
} from '@app/components/filter-panel/filter.types';
import { uniqBy } from 'lodash';

export const getUpdatedFilterList = (
  formData: FilterTypeView,
  filters: IFilter[],
  skippedFilterTypes: string[],
): IFilter[] =>
  filters.map((filter: IFilter) => {
    if (skippedFilterTypes.includes(filter.type) || !filter.items) {
      return { ...filter };
    }

    const filterFormData = formData[filter.id];
    const isSelected =
      filter.type === FILTER_PANEL_TYPES.SINGLE_VALUE
        ? (id: string): boolean =>
            filterFormData[FILTER_PANEL_TYPES.SINGLE_VALUE] === id
        : (id: string): boolean => !!filterFormData[id];

    return {
      ...filter,
      ...(filter.items && {
        items: filter.items.map((filterItem: IFilterItem) => ({
          ...filterItem,
          selected: isSelected(filterItem.id),
        })),
      }),
    };
  });

export const convertToFilterItemModel = <T extends { name: string }>(
  items: T[],
): IFilterItem[] =>
  uniqBy(
    items.map((item) => ({
      ...item,
      name: () => item.name,
      id: item.name.toLocaleLowerCase().replace(/ /g, '_'),
    })),
    'id',
  );
